import React, { memo } from "react";
import Button from "../../../theme/button/Button";
import Text from "../../../theme/text/Text";
import Styles from "./BackButton.module.scss";

function BackButton({
    onClick,
    destination,
}: {
    onClick: () => void;
    destination: string;
}) {
    return (
        <Button.Back className={Styles["back-button"]} onClick={onClick} iconVariant="tertiary" variant="none">
            <Text as="span" textVariant="body-2-regular" colorVariant="body-secondary">
                Back to
                {" "}
                {destination}
            </Text>
        </Button.Back>
    );
}

export default memo(BackButton);
